




























































import {Component, Mixins, Ref} from "vue-property-decorator";
import {Api} from "shared/api";
import {AuthService} from "@/services/auth";
import EmployeeMixin from "@/mixins/employee";

@Component({
    components: {}
})
export default class Login extends Mixins(EmployeeMixin) {
    private login = {
        username: "",
        password: ""
    }

    private initialized = false;
    private loading = false;
    private success: string | null = null;
    private error: string | null = null;
    @Ref() private readonly usernameInput!: HTMLInputElement;
    @Ref() private readonly passwordInput!: HTMLInputElement;

    private async mounted() {
        if (await this.authorized()) {
            this.$router.push({name: "Home"});
            return;
        }
        this.initialized = true;
        setTimeout(() => this.usernameInput.focus(), 200);
    }

    private async submit(): Promise<boolean> {
        this.success = null;
        this.error = null;

        this.loading = true;
        const response = await Api.auth.Login.Post({
            username: this.login.username,
            password: this.login.password
        });
        this.loading = false;

        if (response.success) {
            this.success = "Login Successful";
            AuthService.setToken(response.result);
            await this.$router.push({name: "Home"});
            return true;
        }
        this.error = response.error;
        return false;
    }
}

